import script from "./StudentView.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentView.vue?vue&type=script&setup=true&lang=js"

import "./StudentView.vue?vue&type=style&index=0&id=6a6a4392&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a6a4392"]])

export default __exports__